export default "__VITE_ASSET__43c6c6a3__$_?component__"